import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import { ProfBody } from "./ProfBody";
import { PersonalBody } from "./PersonalBody";
import { EduBody } from "./EduBody";
import { useCreateEmployeeMutation } from "entitites/employees/api/employeesApi";
import { AccountsBody } from "./AccountsBody";

export const EmployeeCreate = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const handleClose = () => {
    navigate({ pathname: "/", search });
  };

  const [create] = useCreateEmployeeMutation();
  const { register, handleSubmit, formState, control, reset, watch, setError } =
    useForm({
      defaultValues: {
        fio: "",
        profInfo: {
          positionId: "" as unknown as number,
          company: "-",
          direction: "",
          project: "Самокат",
          department: "",
          adviser: "-",
          schedule: "-",
          workTime: "-",
          additionalFields: [{ label: "", value: "" }],
        },
        personalInfo: {
          statusId: "" as unknown as number,
          email: "",
          personalEmail: "-",
          phone: "-",
          personalPhone: "-",
          telegram: "-",
          city: "-",
          dob: "-",
          address: "-",
          additionalFields: [{ label: "", value: "" }],
        },
        accountsInfo: {
          status: "Нужно сделать",
          appl: "",
          accounts: [
            { label: "Infobip", value: "" },
            { label: "Jira/Confluence", value: "" },
            { label: "VPN", value: "" },
            { label: "Power BI", value: "" },
            { label: "Webphone", value: "" },
            { label: "Staff cave", value: "" },
            { label: "Стажёры", value: "" },
            { label: "Эквио (УзнайPro)", value: "" },
            { label: "Rocket.Chat", value: "" },
          ],
        },
        eduInfo: {
          eduStages: [
            { dates: [{ name: "", date: "" }], coachFio: "", position: "" },
          ],
        },
      },
    });

  const { errors } = formState;
  return (
    <Modal
      disableScrollLock={true}
      open={pathname.includes("create")}
      onClose={handleClose}
      aria-labelledby="employee-modal-title"
      aria-describedby="employee-modal-description"
    >
      <Box
        onSubmit={handleSubmit((data) => {
          create(data)
            .unwrap()
            .then(() => {
              reset();
              handleClose();
            })
            .catch((er) =>
              setError("personalInfo.email", {
                message: "Почта уже существует",
              })
            );
        })}
        component="form"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2.5}
        sx={{
          overflowY: "scroll",
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: 825,
          maxHeight: "90%",
          bgcolor: "background.paper",
          borderRadius: "4px",
          boxShadow: 24,
          p: 3.25,
          px: 10,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 0, right: 0 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          fontWeight={700}
          id="employee-modal-title"
          variant="h6"
          component="h2"
        >
          Добавление нового сотрудника
        </Typography>
        <Box display="flex" alignItems="center" fontWeight={600} width="100%">
          ФИО
          <TextField
            inputProps={register("fio", { required: "Пожалуйста введите ФИО" })}
            error={Boolean(errors.fio)}
            helperText={errors.fio?.message}
            label="ФИО"
            size="small"
            sx={{
              ml: "auto",
              width: 400,
            }}
          />
        </Box>
        <ProfBody
          watch={watch}
          register={register}
          errors={errors}
          control={control}
        />
        <PersonalBody
          watch={watch}
          register={register}
          errors={errors}
          control={control}
        />
        <EduBody register={register} control={control} />
        <AccountsBody watch={watch} register={register} control={control} />
        <Box display="flex" gap={2}>
          <Button
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: "text.primary",
            }}
            variant="outlined"
          >
            Назад
          </Button>
          <Button
            type="submit"
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
            }}
            variant="contained"
          >
            Добавить
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
